import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-sorteios',
  templateUrl: './sorteios.component.html',
  styleUrls: []
})
export class SorteiosComponent implements OnInit {

  breadcrumb = '';

  constructor(private readonly router: Router,
              private readonly route: ActivatedRoute) { }

  ngOnInit() {
    this.breadcrumb = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/sorteios.component.ts